import { render, staticRenderFns } from "./View.vue?vue&type=template&id=d5c1d29c"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=d5c1d29c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports